import type { DashboardTaskItem } from "@models";
import type { ReactNode } from "react";
import { DashboardConnectedCard } from "./DashboardConnectedCard";
import { DashboardTaskRows } from "./DashboardTaskRows";

type DashboardOutdatedDueSoonCardProps = {
  tasks: DashboardTaskItem[];
  count?: number;
  actions?: ReactNode;
  selectedDeviceId?: string;
  fallbackDeviceId?: string;
  className?: string;
};

export const DashboardOutdatedDueSoonCard = ({
  tasks,
  count,
  actions,
  selectedDeviceId,
  fallbackDeviceId,
  className,
}: DashboardOutdatedDueSoonCardProps) => {
  return (
    <DashboardConnectedCard
      rootTestId="dashboard-outdated-due-soon-card"
      metricTestId="dashboard-outdated-due-soon-metric-card"
      caption="Tasks overdue/due soon"
      totalNumber={count ?? tasks.length}
      metricClassName="border-red-200 bg-red-50"
      valueClassName="text-red-700"
      sectionLabel="Tasks overdue/due soon"
      sectionTestId="dashboard-outdated-due-soon-result-card"
      actions={actions}
      className={className}
    >
      <div className="min-h-0 flex-1 overflow-hidden">
        <DashboardTaskRows
          tasks={tasks}
          isLoading={false}
          emptyText="No upcoming work across the organization."
          listTestId="dashboard-outdated-due-soon-task-list"
          scrollTestId="dashboard-outdated-due-soon-tasks-scroll"
          selectedDeviceId={selectedDeviceId}
          fallbackDeviceId={fallbackDeviceId}
          preserveTaskOrder
        />
      </div>
    </DashboardConnectedCard>
  );
};
